export const ReactQueryKeys = {
  PatientsQuery: 'patientsQuery',
  HospitalsQuery: 'hospitalsQuery',
  SurgeonsQuery: 'surgeonsQuery',
  EpisodesQuery: 'episodesQuery',
  PreferredHospitalQuery: 'preferredHospital',
  SurgeonEpisodeSummaryQuery: 'surgeonEpisodeSummary',
  EpisodeStatsQuery: 'episodeStats',
  OwnedEpisodesQuery: 'ownedEpisodes',
  UnlinkedPatientsQuery: 'unlinkedPatientsQuery',
  AnnouncementsQuery: 'announcements-query',
};
